export const TestIds = {
	GROUPED_ROW_CHECKBOX: 'grouped-row-checkbox',
	TABLE_ROW: 'table-row',
	TABLE_GROUP_ROW: 'table-group-row',
	TABLE_ROW_MEMO: 'table-row-memo',
	TABLE_GROUP_ROW_MEMO: 'table-group-row-memo',
	NO_DATA_MESSAGE: 'no-data-message',
	TABLE_LOADING_SPINNER: 'table-loading-spinner'
};
